/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { Grid, DialogContentText } from '@material-ui/core';
import * as Roles from '../../constants/role';
import * as actionsProcedimentosNormas from '../../store/procedimentosNormas/actions';
import * as selectorsProcedimentosNormas from '../../store/procedimentosNormas/reducer';
import * as selectorsAuth from '../../store/auth/reducer';
import { Input, DialogDefault, UsuarioSelect, DefaultSelect, OptionSelect, ArquivoContainer } from '../../components';
import moment from 'moment';
import clsx from 'clsx';
import { isInspecaoMtBt } from 'utils';

const createSchema = {
  usuarioIds: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  title: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  moduloId: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const cancelSchema = {
  justificativaCancelamento: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  },
  cancelada: {
    color: "red",
    fontStyle: "italic"
  }
}));

const Formulario = ({ createProcedimentosNormas, updateProcedimentosNormas, findProcedimentosNormasById, procedimentosNormasClearSelected, procedimentosNormasCancelStatus, procedimentosNormasConfirmStatus, 
  selectedProcedimentosNormas, open, id, onClose, authData, userRole, onReload }) => {
  const classes = useStyles();

  const [values, setValues] = useState({});
  const [cancelValues, setCancelValues] = useState({});
  const [openAceitar, setOpenAceitar] = useState(false);
  const [openCancelar, setOpenCancelar] = useState(false);
  const [errors, setErrors] = useState({});
  const [cancelErrors, setCancelErrors] = useState({});

  const getDefaultValues = () => {
    return {
      criadoPorId: authData.id,
      criadoPorNome: authData.nome,
      status: 'AVAILABLE',
    } 
  }

  useEffect(() => {
    if (open && !id) {
      setValues(getDefaultValues());
      setCancelValues({});
    }
  }, [id, open]);

  useEffect(() => {
    if (id) {
      findProcedimentosNormasById(id);
    }
  }, [id, findProcedimentosNormasById]);

  useEffect(() => {
    if (selectedProcedimentosNormas && selectedProcedimentosNormas.id) {
      setValues({
        ...selectedProcedimentosNormas,
        dataCriacao: moment(selectedProcedimentosNormas.dataCriacao).valueOf(),
      });
    } 
  }, [selectedProcedimentosNormas]);

  const onSave = () => {
    const erros = validate(values, createSchema);
    setErrors(erros);
    if (!erros) {
      if (values.id) updateProcedimentosNormas(values.id, values, saveCallback);
      else createProcedimentosNormas(values, saveCallback);
    }
  }

  const saveCallback = success => {
    if (success) {
      onCloseLocal(true);
    }
  }

  const onCloseLocal = (isSave) => {
    procedimentosNormasClearSelected();
    setErrors({});
    setValues(getDefaultValues());
    setCancelValues({});
    setCancelErrors({});
    onClose(isSave);
    onReload();
  }

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const isAdmin = () => userRole === Roles.ADMIN || userRole === Roles.SUPER_ADMIN;
  const isDisabled = () => values.cancelada || values.status !== 'AVAILABLE' || values.criadoPorId !== authData.id;

  return (
    <>
      <DialogDefault
        open={open}
        handlerCancel={() => onCloseLocal(false)}
        handlerConfirm={onSave}
        title="Procedimento e Norma"
        confirmMessage="Salvar"
        contentClassName={classes.contentClassName}
        maxWidth="md"
        readOnly={isDisabled()}
        headerAction={[
          {
            onClick: () => setOpenCancelar(true),
            title: "Cancelar",
            show: isAdmin() && !!values.id && values.status === 'AVAILABLE'
          },
          {
            onClick: () => setOpenAceitar(true),
            title: "Aceitar",
            show: !!values.id && values.status === 'AVAILABLE' && !values.cancelada && values.usuarioIds === authData.id
          },
        ]}
      >
        <Grid container spacing={3} className={classes.gridContainer}>
          {values.cancelada && <Grid item xs={12} className={clsx(classes.fieldContainer, classes.cancelada)}>
            **** Procedimento e Norma cancelado por {values.canceladaPorNome} em {values.dataCanceladaValue}
          </Grid>}
          <Grid item xs={6} className={classes.fieldContainer}>
            <Input
              isRequired
              error={errors && errors.title}
              label="Título"
              name="title"
              onChange={handleChange}
              value={values.title}
              disabled={isDisabled()}
            />
          </Grid>
          <Grid item xs={3} className={classes.fieldContainer}>
            <DefaultSelect
              error={errors && errors.status ? true : false}
              isRequired
              label="Status"
              name="status"
              showEmpty
              options={[
                {id: 'AVAILABLE', nome: 'Disponível'},
                {id: 'CANCEL', nome: 'Cancelada'},
                {id: 'ACCEPTED', nome: 'Aceita'},
              ]}
              onSelect={event => setValues({
                ...values,
                status: event.target.value
              })}
              value={values.status}
              disabled={true}
            />
          </Grid>
          <Grid item xs={3} className={classes.fieldContainer}>
            <Input label="Criado Por" value={values.criadoPorNome} disabled/>
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <OptionSelect
              label="Módulo"
              codigo="PROCEDIMENTOS_NORMAS_MODULOS"
              isRequired
              error={errors && errors.moduloId}
              onSelect={moduloId => setValues({
                ...values,
                moduloId
              })}
              value={values.moduloId}
              disabled={isDisabled()}
            />
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <OptionSelect
              label="Tipo de Serviço"
              codigo="TIPO_SERVICO"
              onSelect={tipoServicoId => {
                setValues({
                  ...values,
                  tipoServicoId,
                  subtipoId: null,
                });
                setErrors({});
              }}
              value={values.tipoServicoId}
              disabled={isDisabled()}
            />
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <OptionSelect
              label="Subtipo da Inspeção"
              codigo="NSIR_SUBTIPOS"
              onSelect={subtipoId => setValues({
                ...values,
                subtipoId
              })}
              value={values.subtipoId}
              disabled={isDisabled() || !isInspecaoMtBt(values?.tipoServicoId)}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <UsuarioSelect
              label="Usuários"
              onSelect={usuarioIds => setValues({ ...values, usuarioIds}) }
              ativo
              value={values.usuarioIds}
              isRequired
              error={errors && errors.usuarioIds}
              disabled={isDisabled()}
              multiSelect={!values.id}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              label="Descrição"
              name="descricao"
              onChange={handleChange}
              placeholder="descricao"
              value={values.descricao}
              rows={4}
              multiline
              disabled={isDisabled()}
            />
          </Grid>
          {values.status === "CANCEL" && <>
            <Grid item xs={3} className={classes.fieldContainer}>
              <Input label="Cancelada Por" value={values.canceladaPorNome} disabled/>
            </Grid>
            <Grid item xs={3} className={classes.fieldContainer}>
              <Input label="Data de Cancelamento" value={values.dataCanceladaValue} disabled />
            </Grid>
            <Grid item xs={12} className={classes.fieldContainer}>
              <Input
                isRequired
                error={errors && errors.justificativaCancelamento}
                label="Justificativa de Cancelamento"
                name="justificativaCancelamento"
                onChange={handleChange}
                placeholder="justificativaCancelamento"
                value={values.justificativaCancelamento}
                rows={4}
                multiline
                disabled
              />
            </Grid>
          </>}
          <ArquivoContainer 
            arquivos={values.arquivos}
            onSave={arquivos => setValues({ ...values, arquivos })}
            disabled={isDisabled()}
          />
        </Grid>
      </DialogDefault>
      <DialogDefault
        open={openAceitar}
        useFullScreen={false}
        handlerCancel={() => setOpenAceitar(false)}
        handlerConfirm={() => { 
          procedimentosNormasConfirmStatus(values.id, isSave => {
            if (isSave) {
              setOpenAceitar(false); 
              onCloseLocal(isSave);
            }
          });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText> Deseja realmente confirmar o Procedimento e Norma? </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={openCancelar}
        useFullScreen={false}
        handlerCancel={() => setOpenCancelar(false)}
        handlerConfirm={() => { 
          const errors = validate(cancelValues, cancelSchema);
          setCancelErrors(errors);
          if (!errors) {
            procedimentosNormasCancelStatus(values.id, cancelValues, isSave => {
              if (isSave) {
                setOpenCancelar(false); 
                onCloseLocal(isSave);
              }
            });
          }
        }}
        title="Cancelamento do Procedimento e Norma"
        confirmMessage="Confirmar"
        cancelMessage="Cancelar"
      >
        <Grid item xs={12} className={classes.fieldContainer}>
          <Input
            isRequired
            error={cancelErrors && cancelErrors.justificativaCancelamento}
            label="Justificativa de Cancelamento"
            name="justificativaCancelamento"
            onChange={event => {
              setCancelValues({ "justificativaCancelamento": event.target.value });
            }}
            placeholder="justificativaCancelamento"
            value={cancelValues.justificativaCancelamento}
            rows={4}
            multiline
          />
        </Grid>
      </DialogDefault>
    </>
  );
};

const mapStateToProps = state => ({
  selectedProcedimentosNormas: selectorsProcedimentosNormas.getSelectedProcedimentosNormas(state),
  authData: selectorsAuth.getAuth(state),
  userRole: selectorsAuth.getRole(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsProcedimentosNormas,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
